<template>
  <b-modal
    id="modal-confirm-upload-file"
    hide-footer
    centered
    :noCloseOnBackdrop="isBusy"
    :noCloseOnEsc="isBusy"
    :hideHeaderClose="isBusy"
  >
    <div class="col-12 d-flex flex-column align-items-center modalsTables">
      <p class="text-center mb-5">
        <strong
          >Adjuntar Autorización Firmada</strong
        >
      </p>

      <div>
        <UploadFilePdf
          label="Adjuntar formato con firma"
          id="file-pdf-autorizacion"
          @uploadFile="(value) => uploadFile(value)"
        />
      </div>

      <div
        class="w-100 mt-5 d-flex align-content-center justify-content-center"
      >
        <button
          class="button-send-email"
          style="color: white !important"
          :disabled="isBusy || !file"
          @click.prevent="saveFile()"
        >
          Confirmar
          <b-spinner class="ml-2" v-if="isBusy" />
        </button>
      </div>
      <b-alert
        dismissible
        variant="danger"
        show
        class="mt-4"
        v-if="isError"
      >
        <p>Error en el servidor. Intente nuevamente</p>
      </b-alert>
    </div>
  </b-modal>
</template>

<script>
import UploadFilePdf from "../UploadFilePdf.vue";
import {
  saveFileAuthorization,
} from "@/services/health-tracker/saludCondition/service";
export default {
  components: {
    UploadFilePdf,
  },
  data() {
    return {
      isBusy: false,
      isError: false,
      file: null,
    }
  },
  methods: {
    async uploadFile(data) {
      const me = this;
      me.file = data?.file;
    },
    async saveFile() {
      const me = this;
      me.isBusy = true;
      me.isError = false;
      const formData = new FormData();
      formData.append("authorization_file", me.file);
      try {
        const { data } = await saveFileAuthorization(formData);
        me.$emit("successFileAuthorization", data.identifier);
        me.$bvModal.hide("modal-confirm-upload-file");
        me.$bvModal.show("modal-success-morbidity");
      } catch (error) {
        console.log(error);
        me.isError = true;
      } finally {
        me.isBusy = false;
      }
    },
  }
};
</script>
<style>
.button-send-email {
  border: 1px solid #5d5fef;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background-color: #5d5fef;
  display: flex;
  align-items: center;
}
</style>
